import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function JamesThreattPage() {
  return <AttorneyBioTemplate attorney={attorneys['james-threatt-esq']} />;
}
